// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".default_div{width:100%;height:100%;min-height:100%;background-color:#fff;display:flex;flex-direction:row;justify-content:center;align-items:center}", ""]);
// Exports
module.exports = exports;
